import { ComboboxPrimitive as e, comboboxChipRemoveVariants as t, comboboxChipVariants as n, comboboxDescriptionVariants as r, comboboxInputGroupVariants as i, comboboxItemVariants as a } from "./combobox-primitive.js";
import { ComboboxChips as o, ComboboxContent as s, ComboboxCreateOption as c, ComboboxDrawerFooter as l, ComboboxEmpty as u, ComboboxGroup as d, ComboboxGroupLabel as f, ComboboxGroupOptions as p, ComboboxInput as m, ComboboxInputGroup as h, ComboboxList as g, ComboboxOption as _, ComboboxRoot as v, ComboboxStatus as y, ComboboxTrigger as b } from "./combobox.js";
//#region src/combobox/index.ts
var x = Object.assign(v, {
	Root: v,
	Label: e.Label,
	InputLabel: e.InputLabel,
	Description: e.Description,
	Error: e.Error,
	Input: m,
	InputGroup: h,
	Chips: o,
	Value: e.Value,
	Clear: e.Clear,
	Icon: e.Icon,
	Chip: e.Chip,
	ChipRemove: e.ChipRemove,
	LeadingIcon: e.LeadingIcon,
	OverflowBadge: e.OverflowBadge,
	Trigger: b,
	Content: s,
	List: g,
	Option: _,
	CreateOption: c,
	Item: e.Item,
	ItemText: e.ItemText,
	ItemIndicator: e.ItemIndicator,
	ItemCheckbox: e.ItemCheckbox,
	Row: e.Row,
	Separator: e.Separator,
	Group: d,
	GroupLabel: f,
	GroupOptions: p,
	Status: y,
	Empty: u,
	DrawerFooter: l
});
//#endregion
export { x as Combobox, e as ComboboxPrimitive, t as comboboxChipRemoveVariants, n as comboboxChipVariants, r as comboboxDescriptionVariants, i as comboboxInputGroupVariants, a as comboboxItemVariants };
